const OPEN_MENU = 'OPEN_MENU';

function openMenu () {
	return {
		type: OPEN_MENU,
	};
}

const CLOSE_MENU = 'CLOSE_MENU';

function closeMenu () {
	return {
		type: CLOSE_MENU,
	};
}

export default {
	OPEN_MENU,
	openMenu,

	CLOSE_MENU,
	closeMenu,
};
